import { Dropdown, Flex } from 'antd';
import styled from 'styled-components';

interface IBottomContainer {
	open: boolean;
}

export const Widget = styled.div`
    position: relative;
    overflow: hidden;
`;

export const WidgetMenu = styled(Dropdown)`
    position: absolute;
    z-index: 100000;
    top: 0;
    right: 0;
`;
export const BottomContainer = styled(Flex)<IBottomContainer>`
    width: 100%;
    border-top: 2px solid #001529;
    position: fixed;
    bottom: ${(p) => (p.open ? '0' : '-45vh')};
    left: 0;
    height: 45vh;
    transition: 0.5s ease-in-out;
    padding-top: 10px;
    gap: 20px;
    padding: 20px;
    background-color: #f0f0f0;

    @media (max-width: 768px) {
        height: calc(100vh - 80px);
        bottom: ${(p) => (p.open ? '0' : 'calc(-100vh + 80px)')};
        flex-direction: column;
        
    }
`;

interface IBottomContainerTrigger {
	open: boolean;
}

export const BottomContainerTrigger = styled.div<IBottomContainerTrigger>`
    position: absolute;
    left: 90vw;
    width: 40px;
    height: 20px;
    background-color: #001529;
    top: -20px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5px;
    cursor: pointer;
    border-radius: 5px 5px 0px 0px;

    gap: 10px;

    &::before {
        content: '';
        position: absolute;
        bottom: -5px;
        left: -15px;
        width: 10px;
        height: 20px;
        border-radius: 0 50%;
        transform: rotate(90deg);
        box-shadow: 0px -10px 0 0 #001529;
        background-color: transparent;
    }

    &::after {
        content: '';
        position: absolute;
        bottom: -5px;
        right: -15px;
        width: 10px;
        height: 20px;
        border-radius: 0 50%;
        transform: rotate(90deg) scaleY(-1);
        box-shadow: 0px -10px 0 0 #001529;
        background-color: transparent;
    }

    svg {
        transition: 0.3s;
        transform: scale(1.5, 1) rotate(${(p) => (p.open ? '270deg' : '90deg')});
        color: white;
    }

    @media (max-width: 768px) {
        svg {
            z-index: 2;
        }
    }
`;

export const EditorsContainer = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
`;

export const BottomContainerActions = styled.div`
    width: 300px;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;

    @media (max-width: 768px) {
        width: 100%;
    }
`;

export const PreviewContainer = styled.div`
    width: 300px;
    min-height: 85%;
    border: 1px solid rgba(0, 0, 0, 0.1);
    display: flex;
    justify-content: center;
    align-items: center;
    transition: 0.3s;
    z-index: 2;

    @media (max-width: 768px) {
        width: 100%;
    }
`;
